import React from 'react';
import PropTypes from 'prop-types';

import Text from 'components/Text';
import { COLOR_GRAY_90 } from 'styles/variables/colors';
import { Container } from './styles';

const Props = {
  children: PropTypes.node.isRequired,
};

export default function GalleryHomeTitle({ children }) {
  return (
    <Container>
      <Text variant="h2" size="1.5rem" fillColor={COLOR_GRAY_90} weight="bold">
        {children}
      </Text>
    </Container>
  );
}

GalleryHomeTitle.propTypes = Props;
